import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export function blockBannersSliderScript() {
    document.addEventListener('DOMContentLoaded', function () {
        const blocksSmallTitle = document.querySelectorAll('.title_desc_slider_button__sliders');

        blocksSmallTitle.forEach(block => {
            let blockTitle = new Splide(block, {
                type: 'loop',
                rewind: false,
                autoplay: false,
                perPage: 4.3,
                perMove: 1,
                gap: 10,
                pagination: false,
                arrows: true,
                autoWidth: true,
                height: '190px',
                breakpoints: {
                    992: {perPage: 3.2},
                    599: {perPage: 2.1},
                },
            });

            blockTitle.mount()
        });
    })
}